module.exports = __webpack_public_path__ + "img/qa.a66dcdd5.svg";